@if (hasPermission()) {
    <button
        type="button"
        id="moveToolBtn"
        class="btn btn-default nlr-icon-btn"
        [title]="getTooltip()"
        [ngClass]="{active: isActive(), 'nlrp-suspended': isSuspended()}"
        (click)="toggle()"
        [disabled]="isDisabled()">
        <i class="nlrp-icon nlrp-icon-move"></i>
    </button>
}
